export default {"src":"/_next/static/media/telegram.a186ce43.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};